import { render, staticRenderFns } from "./TradePasswordSetting.vue?vue&type=template&id=32abe6c6&scoped=true&"
import script from "./TradePasswordSetting.vue?vue&type=script&lang=ts&"
export * from "./TradePasswordSetting.vue?vue&type=script&lang=ts&"
import style0 from "./TradePasswordSetting.vue?vue&type=style&index=0&id=32abe6c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32abe6c6",
  null
  
)

export default component.exports